import * as React from "react";
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 8, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16,52l32,-40z" }));
export default SvgLine;
